export default __webpack_public_path__ + "static/media/improve.5e169fd1.svg";